<template>
  <!-- 日志维护 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 日志类别 -->
        <el-form-item :label="$t('pages.system.text55')">
          <el-select
            v-model="searchParams.apiName"
            clearable
            :placeholder="$t('pages.system.text55')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作内容 -->
        <el-form-item :label="$t('pages.system.text56')">
          <el-input
            v-model="searchParams.apiInfo"
            :placeholder="$t('pages.system.text56')"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="apiList"
          v-permission="['logDefend:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['logDefend:reset']"
        ></DiluButton>
      </div>
    </div>
    <div class="operation">
      <DiluButton
        type="add"
        @click="apiAdd"
        v-permission="['logDefend:add']"
      ></DiluButton>
    </div>
    <!-- 表格 -->
    <DiluTable :list="tableData" :tableConfig="tableConfig">
      <el-table-column label="#" width="80" align="center">
       <template slot-scope="scope">
          <span>{{ scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <!-- 日志类别 -->
      <el-table-column
        prop="apiName"
        :label="$t('pages.system.text55')"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- 操作内容 -->
      <el-table-column
        prop="apiInfo"
        :label="$t('pages.system.text56')"
        align="center"
      >
      </el-table-column>
      <!-- URL -->
      <el-table-column prop="requestUrl" width="400" label="URL" align="center">
      </el-table-column>
      <!-- 新增时间 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.system.text57')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="apiEdit(scope.row)"
              type="text"
              v-permission="['logDefend:edit']"
              >{{ $t("button.edit") }}</el-button
            >
            <el-button
              @click="apiDelete(scope.row)"
              type="text"
              v-permission="['logDefend:remove']"
              >{{ $t("button.delete") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <LogMaintenanceAdd
      @dialogClose="dialogClose"
      @apiList="apiList"
      :dialogVisible="dialogVisible"
      :isAdd="isAdd"
      :currentRole="currentRole"
      :options="options"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import LogMaintenanceAdd from "./module/logMaintenanceAdd";
export default {
  data() {
    return {
      searchParams: {
        apiInfo: "", // 操作内容
        apiName: "", // 日志类别
        requestUrl: "", //请求地址
      },
      currentRole: {},
      isAdd: 1, // 新增1，编辑2，
      dialogVisible: false, // 新增编辑弹窗
      options: [
        {
          value: "login",
          label: this.$t("pages.login.text7"), //登录
        },
        {
          value: "logout",
          label: this.$t("pages.system.text58"), //登出
        },
        {
          value: "add",
          label: this.$t("button.add"), //新增
        },
        {
          value: "delete",
          label: this.$t("button.delete"), //删除
        },
        {
          value: "edit",
          label: this.$t("button.edit"), //编辑
        },
        {
          value: "query",
          label: this.$t("button.query"), //查询
        },
        {
          value: "import",
          label: this.$t("button.import"), //导入
        },
        {
          value: "export",
          label: this.$t("button.export"), //导出
        },
        {
          value: "review",
          label: this.$t("button.examine"), //审核
        },
        {
          value: "bind",
          label: this.$t("pages.equipment.text42"), //绑定
        },
        {
          value: "unbind",
          label: this.$t("pages.equipment.text43"), //解绑
        },
        {
          value: "other",
          label: this.$t("pages.research.text88"), //其他
        },
      ],
      value: "",
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    LogMaintenanceAdd,
  },
  mounted() {
    this.apiList();
  },
  methods: {
    // 关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    // 重置
    reset() {
      this.searchParams = {
        apiName: "",
        apiInfo: "",
      };
      this.apiList();
    },
    // 日志类别查询
    apiList() {
      this.request.apiList(this.searchParams).then((res) => {
        this.tableData = res.data;
      });
    },
    // 新增日志类别
    apiAdd() {
      this.isAdd = 1;
      this.dialogVisible = true;
    },
    // 编辑日志类别
    apiEdit(e) {
      this.isAdd = 2;
      this.currentRole = e;
      this.dialogVisible = true;
    },
    // 删除日志类别
    apiDelete(e) {
      this.$confirm(this.$t("pages.system.text59"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          this.request.apiDelete({ id: e.id }).then(() => {
            this.$message({
              type: "success",
              message: this.$t("public.text7"),
            });
            this.apiList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.table-operation {
  display: flex;
  justify-content: center;
}
</style>